import React, { useState } from "react";
import { faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import { StarIcon } from "@heroicons/react/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, Link } from "react-router-dom";

const HomeExpertCategories = () => {
  const categories = [
    "Frontend Development",
    "App Development",
    "Data Science",
    "Artificial Intelligence",
    "Mathematics",
    "Backend Development",
    "Hosting/Deployment",
  ];
  const topics = {
    "Frontend Development": ["HTML","CSS","JavaScript", "ReactJs", "Vue.js","Angular.Js","Version Control", "Responsiveness","Redux"],
    "Backend Development": [
      "DSA",
      "Java",
      "NodeJs",
      "Python",
      
      "MongoDb",
      "MySql",
    ],
    "Data Science": ["Python", "Statistics", "Linear Algebra", " Algorithms"],
    "App Development": ["React Native", "Flutter", "Kotlin", "Swift"],
    "Artificial Intelligence": [
      "Python",
      "Machine Learning",
      "Deep Learning",
      "Generative AI",
      "LLM",
    ],
    "Mathematics": ["Algebra"],
    "Hosting/Deployment": ["Cloud Hosting","Web Hosting","VPS Hosting"],
  };
  const [selectedCategory, setSelectedCategory] = useState("Frontend Development");
  const [selectedTopic, setSelectedTopic] = useState();
  const [cards, setCards] = useState([]);
  const [isTopicEmpty, setIsTopicEmpty] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const renderHalfStar = () => {
    return (
      <FontAwesomeIcon
        icon={faStarHalfAlt}
        className="w-4 h-4 text-yellow-500"
      />
    );
  };

 
  const handleTopicClick = async (topic) => {
    setSelectedTopic(topic);
    try {
      const response = await fetch(`${baseUrl}/api/expert/topic/${topic}`);
      const data = await response.json();

      if (data.status === false && data.error && data.error.message) {
        console.error("Error fetching cards:", data.error.message);
        setSelectedTopic("")
        setIsTopicEmpty(true)
      } else {
        console.log(data);
        setIsTopicEmpty(false)
        setCards(data.data);
      }
    } catch (error) {
      console.error("Error fetching cards:", error);
      // Handle network errors or other unexpected errors
    }
  };

  return (
    <div>
        <div className="notice mx-5 lg:mx-44 p-5 my-64 text-2xl border  border-red-600 rounded-lg">
        <h1 className="text-3xl text-red-500 "> Attention:</h1>
        <p>
          Currently, we are only providing sessions in scheduled formats. Soon,
          we will release in-built advanced video calls for instant sessions in
          real time. After this, there will not be any requirement to schedule
          the session and keep remembering the date and time for the session.
          Instant video sessions in real-time will come with great features like
          automated recording, audio transcript, advanced in-built tools and
          session summary. This will increase your experience by drastically
          reducing your time and effort.
        </p>
      </div>
      <div className=" m-5  font-josefin-sans ">
        <div className="font-bold  text-3xl md:text-4xl lg:text-5xl mb-4 text-dark-cyan lg:pt-28 text-center">
          Subject. Exam. Skill. Interview.
        </div>
        <div className="text-center text-2xl pb-16 lg:pb-28">
          We have got you covered!
        </div>
      </div>
  
      <div className="flex flex-col items-center">
        <div className="mx-3 flex flex-wrap  lg:mx-[22rem] justify-between lg:w-2/4">
          {categories.map((category, index) => (
            <div
              key={index}
              className={`text-lg font-bold flex flex-col items-center px-5 py-3 rounded-lg border border-gray-300 ${
                selectedCategory === category
                  ? "bg-blue-600 text-white"
                  : "cursor-pointer"
              } mx-2 mb-4`}
              onClick={() => handleCategoryClick(category)}
            >
              {category}
            </div>
          ))}
        </div>
      </div>

      {selectedCategory && (
        <div className="py-4 px-0 rounded-lg bg-white mt-10 lg:w-2/4 lg:m-auto">
          <div className=" grid grid-cols-2 md:grid-cols-5 gap-4">
            {topics[selectedCategory].map((topic, index) => (
              <button
                key={index}
                className={`cursor-pointer font-semibold bg-gradient-to-r from-[#21E8E6] to-[#0558EE] text-white rounded-md py-2 px-4 text-center hover:from-[#0558EE] hover:to-[#21E8E6] transition-colors duration-300 ${
                  selectedTopic === topic
                    ? "bg-blue-500 text-white"
                    : "bg-blue-200 text-dark-cyan"
                } mx-2`}
                onClick={() => handleTopicClick(topic)}
              >
                {topic}
              </button>
            ))}
          </div>
        </div>
      )}
      {isTopicEmpty && (
        <div className=" mt-5 mx-5 py-2 px-3 border border-gray-300 rounded-lg font-semibold font-josefin-sans shadow-lg lg:w-2/4 lg:mx-auto">
          Hang on! We are working on it.
        </div>
      )}
      {selectedTopic && (
        <div className="flex flex-col items-center">
          <div className="flex  flex-col lg:flex-wrap mt-10 w-screen lg:w-1/2 items-center">
            {cards.map((card, index) => (
              <a href={`/booksession/${card._id}`}>
                <div
                  key={index}
                  className="card bg-white -500 rounded-lg px-5 p-4 border border-gray-300 shadow-lg cursor-pointer flex flex-col m-5"
                >
                  <h1 className="font-bold text-sm text-left mb-2 font-serif">
                    {card.topicHeading}
                  </h1>
                  <div className="profile mt-7 flex">
                    <img
                      className="rounded-full w-14 h-14"
                      src={card.expertId.profileImageUrl}
                      alt={card.expertId.name}
                    />
                    <p className=" ml-2 flex flex-col justify-center">
                      <span className="font-semibold text-[10px]">
                        {card.expertId.name}
                      </span>
                      {/* rating section */}
                      <div className="flex">
                        {[...Array(5)].map((_, index) => {
                          if (index < Math.floor(card.ratings)) {
                            return (
                              <StarIcon
                                key={index}
                                className="w-4 h-4 text-yellow-500"
                              />
                            );
                          } else if (
                            index === Math.floor(card.ratings) &&
                            card.ratings % 1 !== 0
                          ) {
                            return renderHalfStar();
                          } else {
                            return (
                              <StarIcon
                                key={index}
                                className="w-4 h-4 text-gray-300"
                              />
                            );
                          }
                        })}
                      </div>
                    </p>
                  </div>
                  <span className="font-semibold mt-5 flex gap-3 text-[10px]">
                    <img
                      src="/images/language.png"
                      alt=""
                      className="w-5 h-5"
                    />
                    English&nbsp;& Hindi
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeExpertCategories;
